import { Middleware } from "redux";
import { Action } from "@ctra/utils";

/**
 * Admin middleware to manipulate things as desired
 * @returns {Middleware}
 */
const adminMiddleware = (): Middleware => (store) => (next) => (action: Action) => {
  next(action);
};

export default adminMiddleware;
